// Theme color tokens for the MUI palette.
// IMPORTANT: these values must stay in sync with the CSS variables defined in
// src/index.css (:root for light, [data-theme="dark"] for dark).
// MUI's createTheme cannot consume var(--x) strings, so the palette needs
// literal hex values; index.css remains the source of truth for CSS-land.

export const lightTokens = {
  primaryMain: '#111827',
  secondaryMain: '#21b6b7',
  backgroundDefault: '#f9f9f9',
  backgroundPaper: '#ffffff',
  textPrimary: '#124a63',
  textSecondary: '#b3c5cd',
  divider: '#eeeeee',
  successMain: '#16a34a',
  errorMain: '#EF4444',
  warningMain: '#ff9800',
  borderStrong: '#cbd5e1',
  muted: '#94a3b8',
  btnContainedBg: '#111827',
  btnContainedHover: '#1F2937',
  btnContainedText: '#ffffff',
};

export const darkTokens = {
  primaryMain: '#e2e8f0',
  secondaryMain: '#2fd0d1',
  backgroundDefault: '#101418',
  backgroundPaper: '#171c22',
  textPrimary: '#d5e3ec',
  textSecondary: '#8fa7b4',
  divider: '#2a333c',
  successMain: '#4ade80',
  errorMain: '#f87171',
  warningMain: '#ffb74d',
  borderStrong: '#3d4a56',
  muted: '#64748b',
  btnContainedBg: '#e2e8f0',
  btnContainedHover: '#cbd5e1',
  btnContainedText: '#111827',
};
